module.exports = __webpack_public_path__ + "img/personalize-packaging.2988c831.svg";